<template>
    <div>
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> MIS Report </h1>
        </div>
        <div class="tab-content" id="myTabContent">
            <div>
                <div class="tab-pane fade show active" id="" role="tabpanel" aria-labelledby="new-tab">
                    <table id="dt-reports" class="table" style="width:100%">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Total Amount</th>
                            <th>View</th>
                            <th>Download</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="report in reports" :key="report.created_at">
                            <td>Finja Fee Collection - {{report.created_at}}</td>
                            <td>{{report.invoice_amount}}</td>
                            <td><router-link :to="/externalViewReportDetail/+report.created_at" class="action edit"><i class="fas fa-eye"></i></router-link></td>
                            <td><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" @click="exportReport(report.created_at)" ><i class="fas fa-download"></i></a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    var dtTable = null;
    export default {
        data() {
            return {
                reports : null
            };
        },
        mounted() {
            this.getVoucherReport();
        },
        methods: {
            exportReport: function(date){
                var that = this;
                that.$Progress.start();
                var formData = {
                    'date': date,
                }
                axios.post('/api/externalReportDetailsExport', formData,{
                    responseType: 'blob'
                })
                    .then(res => {
                        if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                                type: 'application/vnd.ms-excel'
                            }))

                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'misReportDetails.xls')
                            document.body.appendChild(link)
                            link.click()
                            that.$Progress.finish();
                        }else{
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load data');
                        }
                    })
                    .catch(err => {
                        that.$Progress.fail();
                        that.showAlertBox('error','Error to load data');
                    });
            },
            callDataTable: function(){
                dtTable = $('#dt-reports').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    "searching":true,
                    columnDefs: [ {
                        orderable: false,
                    }],
                    order: [[ 0, "desc" ]],
                });
            },
            getVoucherReport: function(){
                this.$Progress.start();
                axios.get("/api/getExternalMisReport")
                    .then(res => {
                        if(res.status == 200){
                            this.reports    = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error', "Error to load data")
                        }
                    })
                    .then(res => {
                        this.callDataTable();
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        console.log(err);
                        this.showAlertBox('error', "Error to load data")
                    });
            }
        },
        created() {
            //
        }
    }
</script>
